import { Chip } from "@mui/material"
import { CloseOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

import type { InventoryByProductItem } from "@/graphql/codegen/graphql"

interface TransferProductSelectionChipsProps {
  inventories: InventoryByProductItem[]
  onRemove: (selectedInventory: InventoryByProductItem) => void
}

export const TransferProductSelectionChips: FC<TransferProductSelectionChipsProps> = ({ inventories, onRemove }) => {
  if (inventories.length === 0) {
    return null
  }

  return (
    <div className='flex flex-wrap gap-2'>
      {inventories.map((inventory) => (
        <Chip
          key={inventory.product.productId}
          label={`${inventory.product.publicId ?? inventory.product.productId} ${inventory.product.companyProductDescription}`}
          size='small'
          onDelete={() => onRemove(inventory)}
          deleteIcon={<CloseOutlined className='text-gray-900' />}
          className='rounded-sm text-xs'
          data-testid={`transfer.product-selection-chips.chip-${inventory.product.productId}`}
        />
      ))}
    </div>
  )
}
